<template>
  <div class="modal-parent">
    <Loading
      v-model:active="loading"
      :can-cancel="true"
      :is-full-page="fullPage"
      color="#669933"
      loader="spinner"
    />
    <section class="header">
      <div style="margin: 0 auto; width: 96%">
        <div class="header-content">
          <div class="header-content-right">
            <h5 class="modal-caption">Discovery Status</h5>

            <div class="logo-container">
              <img src="../../../assets/releaf-logo.png" alt="releaf-logo" />
            </div>
          </div>

          <div class="icons-container" @click="closeModal">
            <div
              class="x-container"
              style="cursor: pointer"
              @click="closeModal"
            >
              <img src="../../../assets/x-icon.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="border"></div>

    <section class="form-container">
      <form class="form-container-div">
        <TextInput
          placeholder="Accepted"
          @onInputChange="handleInputChange"
          :inputValue="discoveryForm.discovery_status"
          fieldName="status"
          disabled="true"
        />

        <TextInput
          placeholder="Target P1 Price/Ton"
          @onInputChange="handleInputChange"
          :inputValue="discoveryForm.price_per_ton"
          fieldName="price_per_ton"
          disabled="true"
        />

        <TextInput
          placeholder="Buying Price/Ton"
          @onInputChange="handleInputChange"
          :inputValue="discoveryForm.buying_price_per_ton"
          fieldName="buying_price_per_ton"
        />

        <TextInput
          placeholder="Actual Tonnage"
          @onInputChange="handleInputChange"
          :inputValue="discoveryForm.actual_tonnage"
          fieldName="actual_tonnage"
        />

        <TextInput
          placeholder="Amount Payable"
          @onInputChange="handleInputChange"
          :inputValue="discoveryForm.amount_payable"
          fieldName="amount_payable"
          :disabled="true"
        />

        <SelectDropdown
          :options="['Not Yet Paid', 'Partially Paid', 'Fully Paid']"
          dropdownTitle="Payment Status"
          @onSelect="handleSelect"
          :inputValue="discoveryForm.payment_status"
          :reset="reset"
          fieldName="payment_status"
        />

        <TextInput
          placeholder="Amount Paid"
          @onInputChange="handleInputChange"
          :inputValue="discoveryForm.amount_paid"
          fieldName="amount_paid"
          v-if="isAmountPartialPaid"
          style="margin-top: 20px"
        />
      </form>
    </section>

    <div class="border"></div>

    <section class="button-container">
      <div class="btn-container">
        <GreenButton label="Submit" @click="submitDiscovery" />
      </div>
    </section>
  </div>
</template>

<script>
import TextInput from "../../form-inputs/text-input/TextInput.vue";
import SelectDropdown from "../../form-inputs/select-dropdown/SelectDropdown.vue";
import GreenButton from "../../buttons/green-button/GreenButton.vue";
import Loading from "vue-loading-overlay";
import { createToast } from "mosha-vue-toastify";

export default {
  name: "AcceptsModal2",
  components: {
    TextInput,
    SelectDropdown,
    GreenButton,
    Loading,
  },

  data() {
    return {
      discoveryForm: {
        discovery_status: "Accepted",
        price_per_ton: "",
        actual_tonnage: "",
        amount_payable: "",
        buying_price_per_ton: "",
        payment_status: "",
        amount_paid: "",
      },
      loading: false,
      reset: false,
      isAmountPartialPaid: false,
    };
  },

  props: {
    discoveryId: {
      type: String,
      required: true,
    },
  },

  methods: {
    closeModal() {
      this.$emit("onCloseModal");
    },

    handleSelect(obj) {
      this.discoveryForm = {
        ...this.discoveryForm,
        ...obj,
      };
    },

    handleInputChange(obj) {
      this.discoveryForm = {
        ...this.discoveryForm,
        ...obj,
      };
    },

    async submitDiscovery(e) {
      e.preventDefault();

      this.loading = true;

      let {
        discovery_status,
        price_per_ton,
        actual_tonnage,
        amount_payable,
        buying_price_per_ton,
        payment_status,
        amount_paid,
      } = this.discoveryForm;

      if (!actual_tonnage || !buying_price_per_ton || !payment_status) {
        this.loading = false;
        createToast("Please fill all fields", {
          type: "danger",
          position: "top-right",
          timeout: 3000,
        });
        return;
      }

      const id = this.discoveryId;

      const payload = {
        id,
        discovery_status,
        price_per_ton: Number(price_per_ton),
        buy_price_per_ton: Number(buying_price_per_ton),
        actual_tonnage: Number(actual_tonnage),
        amount_payable: Number(amount_payable),
        payment_status,
        amount_paid: Number(+amount_payable - (amount_paid || 0)),
        isApproved: "Approved",
      };

      try {
        const data = await this.$store.dispatch(
          "discoveries/updateDiscoveryStatus",
          payload
        );

        if (data._id) {
          createToast("The discovery status has been updated successfully", {
            type: "success",
            position: "top-right",
            timeout: 3000,

            onClose: () => window.location.reload(),
          });
        }

        this.$emit("onCloseModal", false);

        this.loading = false;
      } catch (error) {
        this.loading = false;
        createToast(error.message, {
          type: "danger",
          position: "top-right",
          timeout: 3000,
        });
      }
    },
  },

  watch: {
    "discoveryForm.payment_status": function (val) {
      if (val === "Partially Paid") {
        this.isAmountPartialPaid = true;
      } else {
        this.isAmountPartialPaid = false;
      }
    },

    "discoveryForm.buying_price_per_ton": function (val) {
      this.discoveryForm.amount_payable =
        val * this.discoveryForm.actual_tonnage;

      this.handleInputChange({
        amount_payable: this.discoveryForm.amount_payable,
      });
    },

    "discoveryForm.actual_tonnage": function (val) {
      this.discoveryForm.amount_payable =
        val * this.discoveryForm.buying_price_per_ton;

      this.handleInputChange({
        amount_payable: this.discoveryForm.amount_payable,
      });
    },
  },
};
</script>

<style scoped>
.modal-parent {
  background-color: #fff;
  height: 100%;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-caption {
  color: #232a34;
  font-weight: 700;
}

.logo-container {
  background-color: #232a34;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo-container img {
  width: 30px;
  height: auto;
}

.icons-container {
  display: flex;
  justify-content: space-between;
  /* border: 1px solid red; */
}

.x-container {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: #dcdbdb;
}

.header-content-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4rem;
}

.border {
  margin-top: 10px;
  background: #fff;
  border-bottom: 1px solid #b3b3b3;
}

.form-container-div {
  width: 72.5%;
  margin: 15px auto 0px auto;
}

.form-container {
  height: auto;
  display: flex;
  margin: 0 auto;
  width: 96%;
}

.btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-container {
  width: 100%;
  height: 5rem;
  background: #fff;
  padding: 1rem;
}
</style>
